<template>
    <div :class="preCls + 'content-box'">
        <div style="margin-top: 30px">
            <div class="contener">
                <div class="form">
                    <Form
                        :model="info"
                        :rules="ruleValidate"
                        :label-width="100"
                    >
                        <Row :gutter="20">
                            <Col span="24">
                                <FormItem label="公司名称" prop="title">
                                    <Input
                                        v-model="info.title"
                                        :maxlength="100"
                                        :disabled="cantEdit"
                                    ></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="20">
                            <Col span="24">
                                <FormItem label="公司税号" prop="taxNum">
                                    <Input
                                        v-model="info.taxNum"
                                        :maxlength="100"
                                        :disabled="cantEdit"
                                    ></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="20">
                            <Col span="24">
                                <FormItem label="公司地址" prop="addr">
                                    <Input
                                        v-model="info.addr"
                                        :maxlength="100"
                                        :disabled="cantEdit"
                                    ></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="20">
                            <Col span="24">
                                <FormItem label="公司电话" prop="tel">
                                    <Input
                                        v-model="info.tel"
                                        :maxlength="100"
                                        :disabled="cantEdit"
                                    ></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="20">
                            <Col span="24">
                                <FormItem label="开户银行" prop="bank">
                                    <Input
                                        v-model="info.bank"
                                        :maxlength="100"
                                        :disabled="cantEdit"
                                    ></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="20">
                            <Col span="24">
                                <FormItem label="银行账号" prop="account">
                                    <Input
                                        v-model="info.account"
                                        :maxlength="100"
                                        :disabled="cantEdit"
                                    ></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="20">
                            <Col span="24">
                                <FormItem label="公司传真" prop="fax">
                                    <Input
                                        v-model="info.fax"
                                        :maxlength="100"
                                        :disabled="cantEdit"
                                    ></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="20">
                            <Col span="24">
                                <FormItem label="公司邮箱" prop="email">
                                    <Input
                                        v-model="info.email"
                                        :maxlength="100"
                                        :disabled="cantEdit"
                                    ></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="20">
                            <Col span="24">
                                <FormItem label="客服热线" prop="hotline">
                                    <Input
                                        v-model="info.hotline"
                                        :maxlength="100"
                                        :disabled="cantEdit"
                                    ></Input>
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>

                    <Button
                        class="btn"
                        v-if="$can('update') && hide"
                        @click="edit"
                    >
                        编辑
                    </Button>
                    <Button
                        class="btn"
                        v-if="isShow"
                        @click="confirm"
                        :loading="loading"
                        type="primary"
                        :disabled="btnDisabled"
                        >确定</Button
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { companyView, companySave, companyUpdate } from '@/api/company'
import { tel } from '_u/validate'
export default {
    data() {
        return {
            info: {
                id: '',
                title: '', // 公司名称
                taxNum: '', // 税号
                addr: '', // 地址
                tel: '', // 电话
                bank: '', // 开户银行
                account: '', // 银行账号
                fax: '', // 传真
                email: '', // 邮箱
                hotline: '', // 客服热线
                ver: '',
            },
            cantEdit: true,
            loading: false,
            id: this.$store.state.user.info.id,
            hide: true,
            isShow: false,
            btnDisabled: false,
            add: false,
        }
    },
    computed: {
        ruleValidate() {
            return {
                title: [{ required: true, message: '公司名称必填' }],
                tel: [{ required: true, message: '客户手机号必填' }],
                taxNum: [{ required: true, message: '公司税号必填' }],
                addr: [{ required: true, message: '公司地址必填' }],
                bank: [{ required: true, message: '开户银行必填' }],
                account: [{ required: true, message: '银行账号必填' }],
                hotline: [{ required: true, message: '客服热线必填' }],
            }
        },
    },
    created() {
        this.fetch()
    },
    methods: {
        fetch() {
            companyView(this.id).then((res) => {
                this.setData(res.data)
            })
        },
        edit() {
            this.cantEdit = false
            this.hide = false
            this.isShow = true
        },
        confirm() {
            this.loading = true
            this.btnDisabled = true
            if (this.add) {
                companySave(this.info)
                    .then(() => {
                        this.$Message.success('保存成功')
                    })
                    .then(() => {
                        return companyView(this.id)
                    })
                    .then((res) => {
                        this.setData(res.data)
                    })
                    .finally(() => {
                        this.cantEdit = true
                        this.hide = true
                        this.isShow = false
                        this.loading = false
                        this.btnDisabled = false
                    })
            } else {
                companyUpdate(this.info)
                    .then(() => {
                        this.$Message.success('修改成功')
                    })
                    .then(() => {
                        return companyView(this.id)
                    })
                    .then((res) => {
                        this.setData(res.data)
                    })
                    .finally(() => {
                        this.cantEdit = true
                        this.hide = true
                        this.isShow = false
                        this.loading = false
                        this.btnDisabled = false
                    })
            }
        },
        setData(data) {
            if (data) {
                var entityData = data.entity
                if (entityData) {
                    this.add = false
                    Object.keys(this.info).forEach((name) => {
                        this.info[name] = entityData[name]
                    })
                } else {
                    this.add = true
                }
            }
            // if(data && data.entity) {
            //     this.add = false
            //     var entityData = data.entity
            //     Object.keys(this.info).forEach((name) => {
            //         this.info[name] = entityData[name];
            //     });
            // } else {
            //     this.add = true
            // }
        },
    },
}
</script>

<style lang="less" scoped>
.contener {
    width: 700px;
    margin: 0 auto;
    & .btn {
        display: inline-block;
        margin-left: 350px;
    }
}
</style>
